import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=6a24da01"
import script from "./Chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Chart.vue?vue&type=style&index=0&id=6a24da01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports